<template>
  <div class="relative">
    <Loader class="extra-soft" :soft="true" v-if="softLoading" />
    <div v-if="comments.length == 0">
      <div style="text-align: right;">
        <textarea v-model="newComment" rows="20" class="pre-wrap full-width full-height"></textarea>
        <button @click="addStylistComment(newComment)">Add</button>
      </div>
    </div>
    <div v-for="comment in comments" :key="comment.id" class="border-bottom">
      <h5 class="no-margin very-small-margin-bottom">Comment #{{ comment.id }}</h5>
      <div style="text-align: right;">
        <textarea v-model="comment.comment" rows="20" class="pre-wrap full-width full-height"></textarea>
        <button @click="updateStylistComment(comment)">update</button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'StylistCommentsModal',
  props: {
    type: {
      type: String,
      default: ''
    },
    customerId: {
      type: Number,
      required: false
    }
  },

  data () {
    return {
      timer: null,
      newComment: '',
      comments: [],
      softLoading: false
    }
  },

  methods: {
    updateStylistComment (comment) {
      let loader
      Vue.api.put('/stylist-comment/' + comment.id, {
        comment: comment.comment,
        user_id: comment.user_id
      }, {
        before: () => loader = this.$loading.show(),
        always: () => loader.hide(),
        callback: () => {
          this.$emit('close')
        }
      })
    },
    addStylistComment (comment) {
      let loader
      if (!comment) return
      Vue.api.post('stylist-comment', {
        comment: comment,
        user_id: this.customerId
      }, {
        before: () => loader = this.$loading.show(),
        always: () => loader.hide(),
        callback: () => {
          this.$emit('close')
        }
      })
    },
    updateAllStylistComments () {
      this.comments.forEach(comment => {
        Vue.api.put('/stylist-comment/' + comment.id, {
          comment: comment.comment,
          user_id: comment.user_id
        }, {})
      })
    }
  },

  mounted () {
    if (this.type == 'stylist') {
      this.timer = setInterval(this.updateAllStylistComments, 10 * 1000)
    }
    Vue.api.get(`/v2/stylist/${this.customerId}/comments`, {}, {
      before: () => this.softLoading = true,
      always: () => this.softLoading = false,
      callback: res => {
        this.comments = res
      }
    })
  },

  beforeDestroy () {
    if (this.timer) clearInterval(this.timer)
  }
}
</script>

<style lang="less" scoped>
.pre-wrap {
  white-space: pre-wrap;
}

.loader.extra-soft {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
